import {BrowserPhotolabTaskXMLParser} from "@vicman-wi/photolab-api-js/parser/BrowserPhotolabTaskXMLParser";
import {PhotolabApi} from "@vicman-wi/photolab-api-js";

const photolabTasksData = {};

/**
 * @param {object} appConfig
 * @param {object} clientConfig
 * @return {PhotolabApi}
 */
export function initPhotolabApi(appConfig, clientConfig) {
  const photolabTaskParser = new BrowserPhotolabTaskXMLParser({
    forceSecureSchemeUrls: true,
  });

  const photolabApi = new PhotolabApi({
    endpoints: PhotolabApi.defaultEndpoints,
    credentials: {
      appId: appConfig.photolab.appId,
      projectName: appConfig.project.name,
      clientBuild: appConfig.build.version,
      clientToken: clientConfig.token,
    },
  }, photolabTaskParser);

  photolabApi.updateTaskDefaults({
    language: clientConfig.lang,
    owner: `web-${appConfig.project.name}`,
    abortAttemptsOnError: true,
    abortMethodsChainOnError: true,
  });

  photolabApi.on("task_added", (event) => {
    if (!appConfig.isDebug) return;
    console.log(`[photolab] task add [${event.extra.tid}] [${event.taskResult.requestId}]`, event);

    photolabTasksData[event.taskResult.requestId] = {
      id: event.extra.tid,
      t: Date.now(),
    };
  });

  photolabApi.on("task_result", (event) => {
    if (!appConfig.isDebug) return;
    if (event.taskResult.status === "InProgress") return;

    const isError = event.taskResult.status !== "OK";
    const taskData = photolabTasksData[event.taskResult.requestId];

    console[isError ? "error" : "log"](`[photolab] task res [${taskData?.id}] [${event.taskResult.requestId}]`, event);

    delete photolabTasksData[event.taskResult.requestId];
  });

  return photolabApi;
}
